import { render, staticRenderFns } from "./textbrigade.vue?vue&type=template&id=537a357b&scoped=true"
import script from "./textbrigade.vue?vue&type=script&lang=js"
export * from "./textbrigade.vue?vue&type=script&lang=js"
import style0 from "./textbrigade.vue?vue&type=style&index=0&id=537a357b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a357b",
  null
  
)

export default component.exports